var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "multi-selection-table-container no-select scroll-fire-fox"
    },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "custom multi-selection-table flex-grow-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.objects,
          page: _vm.pagination.page,
          "sort-by": _vm.pagination.sortBy,
          "sort-desc": _vm.pagination.descending,
          "items-per-page": _vm.pagination.rowsPerPage,
          "fixed-header": "",
          "disable-sort": "",
          "hide-default-header": "",
          "hide-default-footer": ""
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.pagination, "page", $event)
          },
          "update:itemsPerPage": function($event) {
            return _vm.$set(_vm.pagination, "rowsPerPage", $event)
          },
          "update:items-per-page": function($event) {
            return _vm.$set(_vm.pagination, "rowsPerPage", $event)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function() {
                return [
                  _c("thead", [
                    _c(
                      "tr",
                      { staticClass: "table-header" },
                      [
                        _c("th", {
                          staticClass: "object-index",
                          style: _vm.headerStyle
                        }),
                        _vm._v(" "),
                        _c("th", { style: _vm.headerStyle }, [
                          _c("span", { style: _vm.headerLabelStyle }, [
                            _vm._v("ID")
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.headers, function(header) {
                          return _c("table-header-cell", {
                            key: header.label,
                            staticStyle: { "padding-left": "16px" },
                            attrs: {
                              header: header,
                              pagination: _vm.pagination,
                              "sort-icon":
                                _vm.pagination.descending &&
                                header.value === _vm.pagination.sortBy
                                  ? "arrow_drop_up"
                                  : "arrow_drop_down",
                              "header-style": _vm.headerStyle,
                              "header-label-style": _vm.headerLabelStyle
                            }
                          })
                        }),
                        _vm._v(" "),
                        _vm.layerHasTechnicalSite
                          ? _c("th", { style: _vm.headerStyle }, [
                              _c("span", { style: _vm.headerLabelStyle }, [
                                _vm._v(_vm._s(_vm.$tc("TechnicalSite", 1)))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.technicalSiteKeys, function(
                          technicalSiteFieldKey
                        ) {
                          return _c(
                            "th",
                            {
                              key: technicalSiteFieldKey,
                              style: _vm.headerStyle
                            },
                            [
                              _c("span", { style: _vm.headerLabelStyle }, [
                                _vm._v(_vm._s(technicalSiteFieldKey))
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.layerHasNode
                          ? _c("th", { style: _vm.headerStyle }, [
                              _c("span", { style: _vm.headerLabelStyle }, [
                                _vm._v(_vm._s(_vm.$tc("Node", 1)))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.nodeKeys, function(nodeFieldKey) {
                          return _c(
                            "th",
                            { key: nodeFieldKey, style: _vm.headerStyle },
                            [
                              _c("span", { style: _vm.headerLabelStyle }, [
                                _vm._v(_vm._s(nodeFieldKey))
                              ])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ]
              },
              proxy: true
            },
            !_vm.loadingObjects
              ? {
                  key: "item",
                  fn: function(props) {
                    return [
                      _c(
                        "tr",
                        {
                          staticClass: "table-body",
                          class: {
                            selected: _vm.selected.includes(props.index)
                          }
                        },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "object-index",
                              on: {
                                click: function($event) {
                                  return _vm.select(props.index, $event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(props.index + 1) +
                                  "\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "input-disabled",
                              on: {
                                click: function($event) {
                                  return _vm.select(props.index, $event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(props.item[_vm.initials + "_id"]) +
                                  "\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.fields, function(field, fieldIndex) {
                            return _c(
                              "td",
                              {
                                key: fieldIndex + "-" + field.var_name,
                                ref: _vm.getInputRef(props.index, fieldIndex),
                                refInFor: true,
                                class: _vm.editionMode ? field.size : ""
                              },
                              [
                                (!_vm.editionMode ||
                                  (_vm.editionMode &&
                                    field.multi_select_disable &&
                                    field.disable)) &&
                                field.input_type !== "checkbox"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "input-disabled with-select",
                                        on: {
                                          click: function($event) {
                                            return _vm.select(
                                              props.index,
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.getNonEditableValue(
                                                props.item,
                                                field
                                              )
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  : _vm.isStandardInput(field.input_type)
                                  ? _c("input", {
                                      staticClass: "table-input",
                                      class: {
                                        edited: _vm.valueWasChanged(
                                          props.index,
                                          field
                                        ),
                                        "required-not-filled": _vm.requiredWasMadeEmpty(
                                          props.index,
                                          field
                                        )
                                      },
                                      attrs: {
                                        type: _vm.getSpecificStandardInputType(
                                          field.input_type
                                        ),
                                        min: 0
                                      },
                                      domProps: {
                                        value: _vm.getValue(props.item, field)
                                      },
                                      on: {
                                        change: function($event) {
                                          field.input_type === "number" &&
                                          $event.target.value < 0
                                            ? _vm.setValue(
                                                props.index,
                                                field,
                                                0
                                              )
                                            : _vm.setValue(
                                                props.index,
                                                field,
                                                $event.target.value
                                              )
                                        },
                                        keydown: [
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "up",
                                                38,
                                                $event.key,
                                                ["Up", "ArrowUp"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              -1000
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "down",
                                                40,
                                                $event.key,
                                                ["Down", "ArrowDown"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              1000
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "left",
                                                37,
                                                $event.key,
                                                ["Left", "ArrowLeft"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 0
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              -1
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "right",
                                                39,
                                                $event.key,
                                                ["Right", "ArrowRight"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 2
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              1
                                            )
                                          }
                                        ]
                                      }
                                    })
                                  : _vm.isSelectInput(field.input_type) &&
                                    field.var_name ===
                                      _vm.prefix + "_material_id"
                                  ? _c("treeselect", {
                                      staticClass: "multi-selection-select",
                                      class: {
                                        edited: _vm.valueWasChanged(
                                          props.index,
                                          field
                                        ),
                                        "required-not-filled": _vm.requiredWasMadeEmpty(
                                          props.index,
                                          field
                                        )
                                      },
                                      attrs: {
                                        value: _vm.getValue(props.item, field),
                                        options: _vm.materialOptions,
                                        normalizer:
                                          _vm.materialOptionsNormalizer,
                                        "load-options": _vm.loadMaterialOptions,
                                        clearable: _vm.selectIsClearable(field),
                                        disabled: true,
                                        disableFuzzyMatching: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.setValue(
                                            props.index,
                                            field,
                                            $event
                                          )
                                        }
                                      },
                                      nativeOn: {
                                        keydown: [
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "up",
                                                38,
                                                $event.key,
                                                ["Up", "ArrowUp"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              -1000
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "down",
                                                40,
                                                $event.key,
                                                ["Down", "ArrowDown"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              1000
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "left",
                                                37,
                                                $event.key,
                                                ["Left", "ArrowLeft"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 0
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              -1
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "right",
                                                39,
                                                $event.key,
                                                ["Right", "ArrowRight"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 2
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              1
                                            )
                                          }
                                        ]
                                      }
                                    })
                                  : _vm.isSelectInput(field.input_type)
                                  ? _c("treeselect", {
                                      staticClass: "multi-selection-select",
                                      class: {
                                        edited: _vm.valueWasChanged(
                                          props.index,
                                          field
                                        ),
                                        "required-not-filled": _vm.requiredWasMadeEmpty(
                                          props.index,
                                          field
                                        )
                                      },
                                      attrs: {
                                        value: _vm.getValue(props.item, field),
                                        options: _vm.getSpecificListOfOptions(
                                          field,
                                          _vm.getValue(props.item, field)
                                        ),
                                        clearable: _vm.selectIsClearable(field),
                                        disabled: field.multi_select_disable,
                                        disableFuzzyMatching: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.setValue(
                                            props.index,
                                            field,
                                            $event
                                          )
                                        }
                                      },
                                      nativeOn: {
                                        keydown: [
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "up",
                                                38,
                                                $event.key,
                                                ["Up", "ArrowUp"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              -1000
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "down",
                                                40,
                                                $event.key,
                                                ["Down", "ArrowDown"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              1000
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "left",
                                                37,
                                                $event.key,
                                                ["Left", "ArrowLeft"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 0
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              -1
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "right",
                                                39,
                                                $event.key,
                                                ["Right", "ArrowRight"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 2
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              1
                                            )
                                          }
                                        ]
                                      }
                                    })
                                  : field.input_type === "user"
                                  ? _c("treeselect", {
                                      staticClass: "multi-selection-select",
                                      class: {
                                        edited: _vm.valueWasChanged(
                                          props.index,
                                          field
                                        ),
                                        "required-not-filled": _vm.requiredWasMadeEmpty(
                                          props.index,
                                          field
                                        )
                                      },
                                      attrs: {
                                        value: _vm.getValue(props.item, field),
                                        options: _vm.userOptions,
                                        normalizer: _vm.userNormalizer,
                                        "load-options": _vm.loadUserOptions,
                                        clearable: _vm.selectIsClearable(field),
                                        disabled: field.multi_select_disable,
                                        disableFuzzyMatching: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.setValue(
                                            props.index,
                                            field,
                                            $event
                                          )
                                        }
                                      },
                                      nativeOn: {
                                        keydown: [
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "up",
                                                38,
                                                $event.key,
                                                ["Up", "ArrowUp"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              -1000
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "down",
                                                40,
                                                $event.key,
                                                ["Down", "ArrowDown"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              1000
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "left",
                                                37,
                                                $event.key,
                                                ["Left", "ArrowLeft"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 0
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              -1
                                            )
                                          },
                                          function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "right",
                                                39,
                                                $event.key,
                                                ["Right", "ArrowRight"]
                                              )
                                            ) {
                                              return null
                                            }
                                            if (!$event.ctrlKey) {
                                              return null
                                            }
                                            if (
                                              "button" in $event &&
                                              $event.button !== 2
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.changePositionFocus(
                                              props.index,
                                              fieldIndex,
                                              1
                                            )
                                          }
                                        ]
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                field.input_type === "checkbox"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "multi-selection-checkbox-container",
                                        class: {
                                          edited: _vm.valueWasChanged(
                                            props.index,
                                            field
                                          ),
                                          "required-not-filled": _vm.requiredWasMadeEmpty(
                                            props.index,
                                            field
                                          )
                                        }
                                      },
                                      [
                                        _c("v-checkbox", {
                                          staticClass:
                                            "multi-selection-checkbox",
                                          staticStyle: { "z-index": "100" },
                                          attrs: {
                                            "input-value": _vm.valueCheckboxInObject(
                                              props.item,
                                              field
                                            ),
                                            color: _vm.valueWasChanged(
                                              props.index,
                                              field
                                            )
                                              ? "#FFF"
                                              : "#767676",
                                            ripple: false,
                                            disabled: !_vm.editionMode,
                                            "hide-details": true,
                                            disableFuzzyMatching: ""
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.setValue(
                                                props.index,
                                                field,
                                                $event
                                              )
                                            }
                                          },
                                          nativeOn: {
                                            keydown: [
                                              function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "up",
                                                    38,
                                                    $event.key,
                                                    ["Up", "ArrowUp"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                if (!$event.ctrlKey) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.changePositionFocus(
                                                  props.index,
                                                  fieldIndex,
                                                  -1000
                                                )
                                              },
                                              function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "down",
                                                    40,
                                                    $event.key,
                                                    ["Down", "ArrowDown"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                if (!$event.ctrlKey) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.changePositionFocus(
                                                  props.index,
                                                  fieldIndex,
                                                  1000
                                                )
                                              },
                                              function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "left",
                                                    37,
                                                    $event.key,
                                                    ["Left", "ArrowLeft"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                if (!$event.ctrlKey) {
                                                  return null
                                                }
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 0
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.changePositionFocus(
                                                  props.index,
                                                  fieldIndex,
                                                  -1
                                                )
                                              },
                                              function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "right",
                                                    39,
                                                    $event.key,
                                                    ["Right", "ArrowRight"]
                                                  )
                                                ) {
                                                  return null
                                                }
                                                if (!$event.ctrlKey) {
                                                  return null
                                                }
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 2
                                                ) {
                                                  return null
                                                }
                                                $event.preventDefault()
                                                return _vm.changePositionFocus(
                                                  props.index,
                                                  fieldIndex,
                                                  1
                                                )
                                              }
                                            ]
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm.layerHasTechnicalSite
                            ? _c("td", { staticClass: "object-index" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.technicalSiteKeys, function(
                            technicalSiteFieldKey
                          ) {
                            return _c(
                              "td",
                              {
                                key: technicalSiteFieldKey,
                                staticClass: "input-disabled"
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      props.item.technicalsite[
                                        technicalSiteFieldKey
                                      ]
                                    ) +
                                    "\n        "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.layerHasNode
                            ? _c("td", { staticClass: "object-index" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.nodeKeys, function(nodeKey) {
                            return _c(
                              "td",
                              { key: nodeKey, staticClass: "input-disabled" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      !!props.item.technicalsite
                                        ? props.item.technicalsite.node[nodeKey]
                                        : !!props.item.technicalpoint
                                        ? props.item.technicalpoint.node[
                                            nodeKey
                                          ]
                                        : props.item.node[nodeKey]
                                    ) +
                                    "\n        "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  }
                }
              : null
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      !_vm.loading && _vm.fields.length > 0 && _vm.objects.length === 0
        ? _c("div", { staticClass: "table-warning" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("NoObjectsOfTypeInSelectedArea")) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.editSelectedOpen
        ? _c("multiselect-edit-selected-form", {
            attrs: {
              "dialog-is-open": _vm.editSelectedOpen,
              fields: _vm.fields,
              objects: _vm.objects,
              selected: _vm.selected,
              options: _vm.options,
              optionsUser: _vm.userOptions,
              materialOptions: _vm.materialOptions,
              prefix: _vm.prefix
            },
            on: { close: _vm.closeEditSelected, apply: _vm.applyMassEdition }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e58b783", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e58b783","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Multiselect/MultiselectTable.vue
// module id = null
// module chunks = 